module.exports = __webpack_public_path__ + "assets/img/huanjing.02e93e3c.jpg";